{
  "chat": {
    "title": "Chat",
    "empty": "Noch keine Chats",
    "loadError": "Diese Unterhaltung konnte nicht geladen werden",
    "messagePlaceholder": "Nachricht",
    "typing": "{{name}} schreibt …",
    "typingTwo": "{{a}} und {{b}} schreiben …",
    "typingMany": "Mehrere Personen schreiben …",
    "online": "Online",
    "offline": "Offline",
    "unread": "Ungelesen",
    "startDm": "{{name}} eine Nachricht schreiben",
    "members": "Mitglieder",
    "mute": "Diese Unterhaltung stummschalten",
    "unmute": "Stummschaltung aufheben",
    "muted": "Stummgeschaltet"
  },
  "login": {
    "title": "Willkommen zurück!",
    "description": "Gib deine E-Mail-Adresse ein, wir senden dir einen Code zum Anmelden.",
    "input": {
      "label": "E-Mail-Adresse",
      "placeholder": "meine@email.de"
    },
    "button": {
      "label": "Code anfordern",
      "loading": "Sende Code..."
    }
  },
  "verify": {
    "title": "Code eingeben",
    "description": "Gib den Code ein, den wir dir per E-Mail an {{email}} gesendet haben.",
    "input": {
      "label": "Bestätigungscode",
      "placeholder": "00000000"
    },
    "button": {
      "label": "Code bestätigen",
      "loading": "Überprüfe Code..."
    },
    "buttonAbort": {
      "label": "Abbrechen"
    },
    "buttonResend": {
      "label": "Code erneut senden"
    },
    "error": {
      "Invalid or expired OTP.": "Code ist abgelaufen oder ungültig.",
      "invalidOtp": "Code ist abgelaufen oder ungültig."
    }
  },
  "date": "{{value, datetime}}",
  "auth": {
    "logout": {
      "button": "Abmelden",
      "confirmTitle": "Abmelden",
      "confirmMessage": "Bist du sicher, dass du dich abmelden möchtest?",
      "error": "Abmeldung fehlgeschlagen. Bitte versuche es erneut."
    }
  },
  "errors": {
    "types": {
      "authentication": "Authentifizierungsfehler",
      "network": "Verbindungsproblem",
      "generic": "Etwas ist schiefgelaufen"
    },
    "messages": {
      "sessionExpired": "Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.",
      "networkError": "Bitte überprüfe deine Internetverbindung und versuche es erneut.",
      "genericError": "Ein unerwarteter Fehler ist aufgetreten. Du kannst die Seite aktualisieren oder dich abmelden.",
      "noOrg": "Keine Organisation gefunden..."
    },
    "technical": {
      "title": "Technische Details:",
      "retryAttempts": "Wiederholungsversuche: {{current}}/{{max}}"
    },
    "actions": {
      "tryAgain": "Erneut versuchen",
      "loginAgain": "Erneut anmelden",
      "logout": "Abmelden",
      "moreOptions": "Weitere Optionen",
      "chooseAction": "Wähle eine Aktion:",
      "refreshApp": "App aktualisieren",
      "debugData": "Debug-Daten",
      "clearCacheRetry": "Cache leeren & erneut versuchen"
    }
  },
  "common": {
    "currency": "{{value, currency}}",
    "decimalSeparator": ",",
    "loading": "Laden...",
    "cancel": "Abbrechen",
    "confirm": "Bestätigen",
    "error": "Fehler",
    "success": "Erfolg",
    "time": {
      "dayAgo": "vor 1 Tag",
      "daysAgo": "vor {{count}} Tagen",
      "weekAgo": "vor 1 Woche",
      "weeksAgo": "vor {{count}} Wochen",
      "monthsAgo": "vor {{count}} Monaten",
      "secondsAbbr": "s"
    },
    "profile": "Profil"
  },
  "dashboard": {
    "error": {
      "orgNotFound": "Organisation nicht gefunden"
    },
    "quickActions": {
      "media": {
        "title": "Alle Medien",
        "subtitle": "Mediathek durchsuchen"
      },
      "achievements": {
        "title": "Erfolge",
        "subtitle": "Fortschritt anzeigen"
      },
      "profile": {
        "title": "Mitgliedsausweis",
        "subtitle": "Deine Details"
      },
      "membership": {
        "title": "Mitgliedschaft",
        "subtitle": "Modell anzeigen"
      },
      "offers": {
        "title": "Angebote",
        "subtitle": "Verfügbare durchsuchen"
      },
      "invite": {
        "title": "Mitglieder einladen",
        "subtitle": "QR-Code erstellen"
      },
      "chat": {
        "title": "Chat",
        "subtitle": "Mit deinen Gruppen chatten"
      }
    },
    "sections": {
      "featuredVideos": "Empfohlene Videos",
      "lastViewed": "Zuletzt angesehen",
      "bookmarkedVideos": "Gespeicherte Medien",
      "recentAchievements": "Aktuelle Erfolge",
      "viewAllAction": "Alle anzeigen"
    }
  },
  "membership": {
    "paymentRequired": {
      "title": "Zahlung einrichten",
      "subtitle": "Deine Mitgliedschaft wurde in diese Organisation übertragen. Um fortzufahren, richte bitte deine Zahlung mit einer der verfügbaren Zahlungsmethoden ein.",
      "paidUntilNote": "Dein bereits bezahlter Zeitraum wird übernommen — es entstehen keine Kosten vor dem {{date}}.",
      "bonusOffer_one": "Richte deine Zahlung bis zum {{date}} ein und erhalte {{count}} Bonusmonat geschenkt.",
      "bonusOffer_other": "Richte deine Zahlung bis zum {{date}} ein und erhalte {{count}} Bonusmonate geschenkt.",
      "openDashboard": "Zahlung im Web-Dashboard einrichten",
      "openDashboardHint": "Aus Sicherheitsgründen erfolgt die Zahlungseinrichtung im Browser. Du wirst automatisch angemeldet.",
      "checkAgain": "Ich habe die Zahlung abgeschlossen",
      "error": "Die Zahlungseinrichtung konnte nicht gestartet werden. Bitte versuche es erneut."
    },
    "codeOfConduct": {
      "heading": "Verhaltensregeln",
      "subtitle": "Bitte lies den folgenden Text und stimme ihm zu, um diese Organisation weiter nutzen zu können.",
      "acceptLabel": "Ich habe den Text „{{title}}“ gelesen und stimme ihm zu.",
      "accept": "Zustimmen",
      "acceptError": "Deine Zustimmung konnte nicht gespeichert werden. Bitte versuche es erneut.",
      "loadError": "Der Text konnte nicht geladen werden.",
      "retry": "Erneut versuchen",
      "newVersion": "Inzwischen gilt eine neue Fassung. Bitte lies sie und stimme ihr zu."
    },
    "title": "Mitgliedschaft",
    "status": {
      "active": "Aktiv",
      "inactive": "Inaktiv"
    },
    "period": {
      "monthly": "Monatlich",
      "yearly": "Jährlich"
    },
    "pricing": {
      "per": {
        "monthly": "pro Monat",
        "yearly": "pro Jahr"
      }
    },
    "sections": {
      "planDetails": "Details",
      "organization": "Organisation"
    },
    "labels": {
      "billingPeriod": "Abrechnungszeitraum",
      "memberSince": "Mitglied seit",
      "validUntil": "Gültig bis",
      "cancelled":  "Abonnement gekündigt"
    },
    "organization": {
      "memberDescription": "Du bist Mitglied dieser Organisation"
    },
    "management": {
      "title": "Dein Abonnement verwalten",
      "description": "Um Änderungen an deinem Abonnement vorzunehmen, verwende bitte die OctaHub WebApp oder wende dich direkt an {{organizationName}}."
    },
    "dashboard": {
      "title": "Dashboard öffnen",
      "subtitle": "Verwalte dein Abonnement und Einstellungen",
      "openError": "Dashboard konnte nicht geöffnet werden. Bitte versuche es erneut."
    }
  },
  "media": {
    "download": {
      "button": "Herunterladen",
      "available": "Offline verfügbar"
    },
    "screens": {
      "bookmarks": "Gespeicherte Inhalte",
      "lastViewed": "Zuletzt angesehene Inhalte",
      "library": "Medien"
    },
    "bookmark": {
      "save": "Speichern",
      "saved": "Gespeichert",
      "bookmarkLabel": "Lesezeichen",
      "bookmarkedLabel": "Gespeichert"
    },
    "folder": {
      "itemCount_one": "{{count}} Element",
      "itemCount_other": "{{count}} Elemente",
      "folderDescription": "Ordner mit {{count}} Elementen"
    },
    "sharedFolders": {
      "upload": "Hochladen",
      "newFolder": "Neuer Ordner",
      "folderNamePlaceholder": "Ordnername...",
      "uploading": "Wird hochgeladen...",
      "uploadProgress": "{{progress}}%",
      "uploadSuccess": "Datei erfolgreich hochgeladen",
      "uploadError": "Hochladen fehlgeschlagen",
      "uploadErrorMessage": "Beim Hochladen ist ein Fehler aufgetreten. Bitte versuche es erneut.",
      "uploadSubtitle": "Eine Datei in diesen Ordner hochladen",
      "newFolderSubtitle": "Einen neuen Unterordner erstellen"
    },
    "navigation": {
      "previous": "Zurück",
      "next": "Weiter"
    },
    "relatedVideos": "Ähnliche Inhalte",
    "delete": {
      "button": "Löschen",
      "confirmTitle": "Medium löschen",
      "confirmMessage": "Bist du sicher, dass du dieses Element löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
      "success": "Medium erfolgreich gelöscht",
      "error": "Löschen fehlgeschlagen",
      "errorMessage": "Dieses Medium konnte nicht gelöscht werden. Bitte versuche es erneut.",
      "errorInUse": "Dieses Medium wird in einem oder mehreren Angeboten verwendet und kann nicht gelöscht werden."
    }
  },
  "achievements": {
    "title": "Erfolge",
    "subtitle": "Deine erreichten Leistungen",
    "count_zero": "Keine Erfolge erreicht",
    "count_one": "{{count}} Erfolg erreicht",
    "count_other": "{{count}} Erfolge erreicht",
    "earned": "Erreicht {{time}}",
    "emptyState": {
      "title": "Noch keine Erfolge",
      "description": "Absolviere Kurse und Aktivitäten, um deinen ersten Erfolg zu erzielen!"
    }
  },
  "noOrg": {
    "title": "Keine Organisationen gefunden",
    "description": "Du hast noch keinen Zugang zu Organisationen. Bitte kontaktiere deinen Administrator, um Zugang zu einer Organisation zu erhalten, oder schau später noch einmal vorbei.",
    "actions": {
      "title": "Was du tun kannst:",
      "contactAdmin": "Kontaktiere deinen Organisationsadministrator",
      "askInvitation": "Bitte um eine Einladung zum Beitreten",
      "checkAccount": "Überprüfe, ob du das richtige Konto verwendest",
      "tryRelogin": "Versuche, dich ab- und wieder anzumelden"
    }
  },
  "offers": {
    "title": "Angebote",
    "detailsTitle": "Angebotsdetails",
    "notFound": "Angebot nicht gefunden",
    "notFoundMessage": "Dieses Angebot konnte nicht gefunden werden",
    "noOffers": "Derzeit sind keine Angebote verfügbar",
    "purchased": "Gekauft",
    "free": "Kostenlos",
    "purchaseWebOnly": "Kauf nur in Web-App möglich",
    "claimOffer": "Angebot einlösen",
    "purchase": "Kaufen",
    "purchasedBadge": "✓ Du besitzt dieses Angebot bereits",
    "youOwnThis": "Du hast Zugriff auf alle Inhalte in diesem Angebot",
    "missingAchievements": "⚠️ Du hast nicht die erforderlichen Erfolge für dieses Angebot. Es fehlt noch: {{missing}}",
    "mobileNotAvailable": "⚠️ Käufe sind in der mobilen App nicht verfügbar",
    "mobileNotAvailableSubtext": "Bitte besuche unsere Website, um dieses Angebot zu kaufen",
    "price": "Preis:",
    "includedContent": "Enthaltene Inhalte",
    "includedAchievements": "Enthaltene Erfolge",
    "videoCount_one": "{{count}} Video",
    "videoCount_other": "{{count}} Videos",
    "audioCount_one": "{{count}} Audio",
    "audioCount_other": "{{count}} Audios",
    "pdfCount_one": "{{count}} PDF",
    "pdfCount_other": "{{count}} PDFs",
    "documentCount_one": "{{count}} Dokument",
    "documentCount_other": "{{count}} Dokumente",
    "imageCount_one": "{{count}} Bild",
    "imageCount_other": "{{count}} Bilder",
    "achievementCount_one": "{{count}} Erfolg",
    "achievementCount_other": "{{count}} Erfolge",
    "paymentDenied": {
      "title": "Zahlung nicht verfügbar",
      "description": "Dieses Angebot ist in deiner Region nicht zum Kauf verfügbar"
    },
    "pricing": {
      "netAmount": "Nettobetrag"
    },
    "errors": {
      "general": "Fehler",
      "purchaseFailed": "Kauf konnte nicht verarbeitet werden",
      "webOnly": "Käufe sind nur in der Web-Version verfügbar"
    },
    "success": {
      "claimed": "Angebot erfolgreich eingelöst!"
    },
    "paymentProviders": {
      "selectTitle": "Zahlungsmethode auswählen",
      "selectSubtitle": "Wähle, wie du bezahlen möchtest",
      "stripe": {
        "name": "Stripe",
        "description": "Kreditkarte, Debitkarte, Apple Pay, Google Pay"
      },
      "paypal": {
        "name": "PayPal",
        "description": "PayPal-Guthaben, Kreditkarte, Bankkonto"
      }
    },
    "payment": {
      "processing": "Zahlung wird bearbeitet...",
      "success": {
        "title": "Zahlung erfolgreich!",
        "message": "Dein Kauf wurde erfolgreich abgeschlossen. Du hast nun Zugriff auf den Inhalt.",
        "viewOffer": "Angebot anzeigen",
        "backToOffers": "Zurück zu Angeboten"
      },
      "pending": {
        "title": "Zahlung in Bearbeitung",
        "message": "Deine Zahlung wird noch bearbeitet. Dies kann einige Momente dauern...",
        "checkStatus": "Status prüfen"
      },
      "failed": {
        "title": "Zahlung fehlgeschlagen",
        "message": "Deine Zahlung konnte nicht abgeschlossen werden. Bitte versuche es erneut.",
        "tryAgain": "Erneut versuchen"
      }
    }
  },
  "orgSelection": {
    "title": "Organisation auswählen",
    "subtitle": "Wähle eine Organisation, um fortzufahren",
    "switchOrg": "Organisation wechseln",
    "switchOrgSubtitle": "Zu einer anderen Organisation wechseln",
    "currentOrg": "Aktuell"
  },
  "profile": {
    "myPurchases": "Meine Einkäufe",
    "idPrefix": "ID: "
  },
  "settings": {
    "language": {
      "title": "Sprache",
      "subtitle": "Wähle deine bevorzugte Sprache",
      "systemDefault": "Systemstandard"
    },
    "notifications": {
      "title": "Benachrichtigungen",
      "subtitle": "Lege fest, worüber du benachrichtigt werden möchtest",
      "chat": "Chat-Nachrichten",
      "chatHint": "Werde über neue Nachrichten in deinen Unterhaltungen benachrichtigt",
      "seeAll": "Alle Benachrichtigungen ansehen",
      "permissionDenied": "Benachrichtigungen sind für diese App in deinen Geräteeinstellungen deaktiviert."
    }
  },
  "openWebApp": "WebApp öffnen",
  "openWebAppSubtext": "Verwalte dein Konto, Einkäufe und mehr unter {{url}}",
  "openWebAppError": "WebApp konnte nicht geöffnet werden. Bitte versuche es erneut.",
  "invite": {
    "title": "Mitglieder einladen",
    "selectPlan": "Mitgliedschaftsplan auswählen",
    "selectGroup": "Gruppe auswählen",
    "generating": "Wird erstellt...",
    "scanToJoin": "QR-Code scannen zum Beitreten",
    "createAnother": "Weiteren erstellen",
    "error": {
      "createFailed": "Einladung konnte nicht erstellt werden. Bitte versuche es erneut.",
      "noPlans": "Keine Mitgliedschaftspläne verfügbar."
    }
  },
  "notifications": {
    "title": "Benachrichtigungen",
    "empty": "Noch keine Benachrichtigungen",
    "markAllRead": "Alle als gelesen markieren",
    "unread": "Ungelesen",
    "loadError": "Benachrichtigungen konnten nicht geladen werden",
    "chat": {
      "messageGroup": {
        "title": "{{channel}}",
        "body": "{{sender}}: {{preview}}"
      },
      "messageDm": {
        "title": "{{sender}}",
        "body": "{{preview}}"
      }
    },
    "common": {
      "newMessage": "Neue Nachricht"
    }
  }
}
